import { render, staticRenderFns } from "./MyCurrency.vue?vue&type=template&id=cf226f62&"
import script from "./MyCurrency.vue?vue&type=script&lang=js&"
export * from "./MyCurrency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports